package com.macrofocus.nastac

import com.macrofocus.common.properties.PropertyEvent
import com.macrofocus.nastac.components.link.*
import deckgl.util.calculateMercatorCentroid
import deckgl.util.calculateZoomLevel
import kotlinx.browser.window
import org.locationtech.jts.geom.Envelope
import react.FC
import react.Props

enum class LayerGroup {
    INTRO {
        override val viewStyles: List<ViewStyle> = listOf(ViewStyle.INTRO)

        override val source: List<FC<Props>> = listOf()

        override fun apply(dataLoader: DataLoader, event: PropertyEvent<ViewStyle>?) {
        }
    },
    GEOGRAPHY {
        override val viewStyles: List<ViewStyle> = listOf(ViewStyle.GEOGRAPHY, ViewStyle.CSHAPES, ViewStyle.HEG, ViewStyle.RSHAPES, ViewStyle.PSPM)

        override val source: List<FC<Props>> = listOf(CShapesEuropeLink, HEGLink, RShapesLink)

        override fun apply(dataLoader: DataLoader, event: PropertyEvent<ViewStyle>?) {
            if(event != null && event.oldValue.layerGroup != LayerGroup.GEOGRAPHY) {
                dataLoader.minYear.value = 1816
                dataLoader.maxYear.value = 2016
                if(dataLoader.shiftValue.value < dataLoader.minYear.value || dataLoader.shiftValue.value > dataLoader.maxYear.value) {
                    dataLoader.shiftValue.value = dataLoader.minYear.value
                }

                // SELECT ST_Envelope(ST_Union(the_geom)) AS total_envelope FROM dbe."HEG";
                // POLYGON ((-24.48 29.92, -24.48 77.02, 68.82000000000001 77.02, 68.82000000000001 29.92, -24.48 29.92))
                //            val envelope = Envelope(-24.54, 68.94, 33.64, 77.02)
                val envelope = Envelope(-24.48, 68.82000000000001, 29.92, 77.02)
                val zoom = calculateZoomLevel(
                    envelope.minX,
                    envelope.minY,
                    envelope.maxX,
                    envelope.maxY,
                    window.innerWidth,
                    window.innerHeight
                )
                dataLoader.threeDZoom.value = zoom
                val centroid = calculateMercatorCentroid(envelope)
                dataLoader.threeDLatitude.value = centroid.y
                dataLoader.threeDLongitude.value = centroid.x
            }
        }
     },
    GEOPOLITICS {
        override val viewStyles: List<ViewStyle> = listOf(ViewStyle.GEOPOLITICS, ViewStyle.GEOPOLITICS_EXCL, ViewStyle.GEOPOLITICS_KIN)

        override val source: List<FC<Props>> = listOf(CShapesLink, EPRLink)

        override fun apply(dataLoader: DataLoader, event: PropertyEvent<ViewStyle>?) {
            if(event != null && event.oldValue.layerGroup != LayerGroup.GEOPOLITICS) {
                dataLoader.minYear.value = 1946
                dataLoader.maxYear.value = 2023
                if(dataLoader.shiftValue.value < dataLoader.minYear.value || dataLoader.shiftValue.value > dataLoader.maxYear.value) {
                    dataLoader.shiftValue.value = dataLoader.maxYear.value
                }

                // val envelope = Envelope(5.9559, 10.4921, 45.8179, 47.8085)
                // SELECT ST_Envelope(ST_Union(geometry)) AS total_envelope FROM import.cshapes
                // POLYGON ((-180 -55.90222696824397, -180 83.11387316122486, 180 83.11387316122486, 180 -55.90222696824397, -180 -55.90222696824397))
                val envelope = Envelope(-180.0, 180.0, -55.90222696824397, 83.11387316122486)
                val zoom = calculateZoomLevel(envelope.minX, envelope.minY, envelope.maxX, envelope.maxY, window.innerWidth, window.innerHeight)
                dataLoader.threeDZoom.value = zoom
                val centroid = calculateMercatorCentroid(envelope)
                dataLoader.threeDLatitude.value = centroid.y
                dataLoader.threeDLongitude.value = centroid.x
//            dataLoader.threeDZoom.value = 2.0
                dataLoader.threeDPitch.value = 0.0
            }
        }
    },
    TILLY {
        override val viewStyles: List<ViewStyle> = listOf(ViewStyle.TILLY)

        override val source: List<FC<Props>> = listOf()

        override fun apply(dataLoader: DataLoader, event: PropertyEvent<ViewStyle>?) {
            if(event != null && event.oldValue.layerGroup != LayerGroup.TILLY) {
//                dataLoader.ethnicity.value = false
//                dataLoader.pspm.value = false
//                dataLoader.railway.value = false
//                dataLoader.geopolitics.value = false

//                dataLoader.borders.value = true

                dataLoader.minYear.value = 1490
                dataLoader.maxYear.value = 1790
                if(dataLoader.shiftValue.value < dataLoader.minYear.value || dataLoader.shiftValue.value > dataLoader.maxYear.value) {
                    dataLoader.shiftValue.value = 1500
                }

//                dataLoader.population.value = false
//                dataLoader.depthTest.value = false

                // SELECT ST_Envelope(ST_Union(the_geom)) AS total_envelope FROM dbe.AbramsonmaxClippedLagged;
                // POLYGON ((-10.48 35.4, -10.48 71.16, 66.58 71.16, 66.58 35.4, -10.48 35.4))
                val envelope = Envelope(-10.48, 66.58, 35.4, 71.16)
                val zoom = calculateZoomLevel(envelope.minX, envelope.minY, envelope.maxX, envelope.maxY, window.innerWidth, (window.innerHeight * 0.6).toInt())
                dataLoader.threeDZoom.value = zoom
                val centroid = calculateMercatorCentroid(envelope)
                dataLoader.threeDLatitude.value = centroid.y
                dataLoader.threeDLongitude.value = centroid.x

//            dataLoader.threeDZoom.value = 4.0
                dataLoader.threeDPitch.value = 0.0 // 60.0
             }
        }
    },
    REPLICATION {
        override val viewStyles: List<ViewStyle> = listOf(ViewStyle.REPLICATION)

        override val source: List<FC<Props>> = listOf()

        override fun apply(dataLoader: DataLoader, event: PropertyEvent<ViewStyle>?) {
        }
    };

    abstract val viewStyles: List<ViewStyle>

    open abstract val source: List<FC<Props>>

    fun isPartOfGroup(viewStyle: ViewStyle): Boolean {
        return viewStyles.contains(viewStyle)
    }

    abstract fun apply(dataLoader: DataLoader, event: PropertyEvent<ViewStyle>?)
}